import { render, staticRenderFns } from "./Publisher.vue?vue&type=template&id=2989b3b6&scoped=true&"
import script from "./Publisher.vue?vue&type=script&lang=js&"
export * from "./Publisher.vue?vue&type=script&lang=js&"
import style0 from "./Publisher.vue?vue&type=style&index=0&id=2989b3b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989b3b6",
  null
  
)

export default component.exports